<template>
  <div id="marquee">
    <marquee class="prize-marque text-light padding-horizontal-10" v-if="texts.length">
      <div class="marquee-text padding-vertical-10" v-for="text in texts">{{text}}</div>
    </marquee>
    <div class="wrapper" v-else>
      <div class="animate comment full-width padding-horizontal-10"></div>
    </div>
  </div>
</template>

<script>
  import { globals } from "@/mixins/globals"
  import axios from 'axios';
  export default {
    mixins: [globals],
    data() {
      return {
        page: 1,
        texts: [],
      }
    },
    methods: {
      getWinnersList() {
        var self = this;
        var url = this.$store.getters.gamesDomain+'/wins_text?partner='+self.partnerID;
        if(self.gameID) {
          url += "&game_id="+self.gameID;
        }
        var headers = this.$store.getters.headers;

        axios.get(url, {
          headers: headers,
          params: {
            page: self.page,
          }
        }).then((resp) => {
          if(resp.status == 200 && resp.data.success) {
            var data = resp.data;
            var texts = data.texts;
            if(texts.length > 0) {
              if(self.page == 1) {
                self.texts = texts;
              } else {
                self.texts.push(texts);
              }

              if(texts.length == 50) {
                self.page += 1;
              } else {
                self.page;
              }
            } else {
              console.log("No texts to display!");
            }
          } else {
            self.alertPopup(true, resp.data.message);
          }
        })

      }
    },
    created() {
      var self = this;
      self.getWinnersList();
      setInterval(function() {
        if(self.texts && self.texts.length == (self.page * 50)) {
          self.getWinnersList();
        }
      }, 20000);
    }
  }
</script>

<style>
  .prize-marque {
    background: #5e1010;
    height: 16px;
  }
  .marquee-text {
    display: inline;
  }
</style>